import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { Blast } from '@/pages/BlastsPage.types'

export function BlastDeletionDialog({
  blast,
  pending,
  onClose,
  onDelete,
}: {
  blast: Blast | null
  pending: boolean
  onClose: () => void
  onDelete: (blast: Blast) => void
}) {
  return (
    <Dialog open={Boolean(blast)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete draft?</DialogTitle>
          <DialogDescription>
            This permanently removes “{blast?.subject}”. This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Keep draft
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={pending || !blast}
            onClick={() => blast && onDelete(blast)}
          >
            {pending ? 'Deleting…' : 'Delete draft'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
